import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
import PageNotFound from './views/PageNotFound.vue'
import PageNotAllowed from './views/PageNotAllowed.vue'

import DashboardRoutes from './modules/dashboard/routes'
import OrdersSalesRoutes from './modules/orders-sales/routes'
import LogBooksRoutes from './modules/logbooks/routes'
import WebsiteRoutes from './modules/website/routes'
import PromotionsRoutes from './modules/promotions/routes'
import InventoryRoutes from './modules/inventory/routes'
import POSRoutes from './modules/pos/routes'
import CustomersRoutes from './modules/customers/routes'
import RangeMembershipsRoutes from './modules/range_memberships/routes'
import ReportsRoutes from './modules/reports/routes'

Vue.use(VueRouter)

const routes = [
    // {
    //     path: '/',
    //     redirect: '/dashboard'
    // },
    ...DashboardRoutes,
    ...OrdersSalesRoutes,
    ...LogBooksRoutes,
    ...WebsiteRoutes,
    ...PromotionsRoutes,
    ...InventoryRoutes,
    ...POSRoutes,
    ...CustomersRoutes,
    ...RangeMembershipsRoutes,
    ...ReportsRoutes,
    {
        path: '/not-allowed',
        name: 'Not Allowed',
        component: PageNotAllowed
    },
    {
        path: '*',
        name: '404',
        component: PageNotFound
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
